import apiHttpClient from "./ApiHttpService";

export default class BugReportService {
  submitBugReport(model) {
    return apiHttpClient.post("UserFeedback/submitBugReport", model);
  }
}
